import ModalLayout from 'components/ModalLayout';
import Text from 'components/Text/Text';
import {
	CreateScheduleContext,
	ICreateScheduleContext,
} from 'modules/CustomersAndRestaurants/Restaurants/RestaurantFullInfo/components/RestaurantFullInfoModal/components/Tabs/components/SoftwareTab/components/ScheduleView/components/ModalWindows/CreateScheduleModal/createScheduleModalContext/createScheduleModalState/createScheduleModalContext';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from 'modules/CustomersAndRestaurants/Restaurants/RestaurantFullInfo/restaurantFullInfoState/restaurantFullInfoContext';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import PushTypeSelect from './components/PushTypeSelect';
import ScheduleField from './components/ScheduleField';
import BtnBlock from './components/BtnBlock';
import ModalWindows from './components/ModalWindows';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './CreateScheduleModal.module.scss';

interface ICreateScheduleModal {
	isVisible: boolean;
	onFailureEvent: () => void;
}

const CreateScheduleModal: React.FC<ICreateScheduleModal> = ({ isVisible, onFailureEvent }) => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { setDataForSubmit, changeTypeOfModalWindow, setPushType, changeSchedule, resetFields, pushType, schedule } =
		useContext<ICreateScheduleContext>(CreateScheduleContext);

	const [form] = Form.useForm();

	useEffect(() => {
		if (isVisible) {
			form.setFieldsValue({ pushType });
			form.setFieldsValue({ schedule: schedule ? moment(schedule) : '' });
		}
	}, [pushType, schedule, isVisible]);

	const submit = () => {
		restaurantForFullInfo &&
			setDataForSubmit({
				customerId: restaurantForFullInfo.customerId,
				restaurantIds: [restaurantForFullInfo.id],
				type: pushType,
				scheduledDate: schedule,
			});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleCloseModal = () => {
		resetFields();
		onFailureEvent();
	};

	return (
		<ModalLayout isVisible={isVisible} setIsShowModal={handleCloseModal} data-test="CreateScheduleModal">
			<Text
				className={style.title}
				translationNameSpace="form"
				translationKey="createScheduledPushHeading"
				size="xxl"
				weight="bold"
			/>
			<Form
				className={style.form}
				form={form}
				name="basic"
				onFinish={submit}
				onKeyPress={preventDefaultForEnterKey}
				layout="vertical">
				<div className={style.wrapper}>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="pushHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<div className={style.row}>
							<PushTypeSelect setPushType={setPushType} />
							<ScheduleField schedule={schedule} changeSchedule={changeSchedule} />
						</div>
					</div>
					<div className={style.buttonBlock}>
						<BtnBlock />
					</div>
				</div>
			</Form>
			<ModalWindows />
		</ModalLayout>
	);
};

export default React.memo(CreateScheduleModal);
